var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedemptionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M54.0414 32.9474V40.1542C54.0414 43.9224 50.9733 46.9904 47.2052 46.9904H37.9392C34.1711 46.9904 31.103 43.9224 31.103 40.1542V32.9474C31.103 30.2705 33.2857 28.0879 35.9625 28.0879H49.1613C51.8381 28.0879 54.0208 30.2705 54.0208 32.9474H54.0414Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3736 25.2463H47.4113C48.5026 25.2463 49.388 24.3609 49.388 23.2696V19.6662C49.388 18.5749 48.5026 17.6895 47.4113 17.6895H4.68499C3.59366 17.6895 2.70825 18.5749 2.70825 19.6662V23.2696C2.70825 24.3609 3.59366 25.2463 4.68499 25.2463H29.3736Z",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2355 17.7096C36.3331 16.6389 39.0305 15.0946 40.2454 13.1384C41.1102 11.7382 41.1926 10.1115 40.5336 8.44368C40.06 7.29058 39.4011 6.42576 38.5363 5.86981C37.6921 5.33444 36.7449 5.10794 35.6536 5.1903C33.5739 5.37562 31.2471 6.77581 29.2292 9.06141C27.932 10.544 26.8406 12.2736 26.0582 14.1268C25.2757 12.2736 24.1844 10.544 22.8872 9.06141C20.8693 6.77581 18.5219 5.37562 16.4628 5.1903C15.3921 5.10794 14.4243 5.33444 13.58 5.86981C12.7152 6.42576 12.0357 7.29058 11.5827 8.44368C10.9032 10.1115 11.0062 11.7382 11.8504 13.1384C13.0653 15.0946 15.7421 16.6389 19.8603 17.7096H32.2561H32.2355ZM20.6222 15.6505C16.9981 14.7239 14.6096 13.4679 13.7036 11.9853C13.2094 11.1617 13.1682 10.2969 13.58 9.26731C14.0948 7.99067 14.8773 7.37295 15.9686 7.37295C16.051 7.37295 16.1333 7.37295 16.2363 7.37295C17.7188 7.49649 19.5926 8.67018 21.2193 10.5028C22.7018 12.1706 23.8549 14.2297 24.555 16.4124C23.5255 16.2683 22.1047 16.0212 20.6016 15.6505H20.6222ZM27.5201 16.4124C28.2202 14.2503 29.3733 12.1912 30.8559 10.5028C32.4826 8.67018 34.3358 7.49649 35.8389 7.37295C35.9213 7.37295 36.0242 7.37295 36.1066 7.37295C37.1979 7.37295 37.9804 7.99067 38.4951 9.26731C38.907 10.3175 38.8864 11.1823 38.3716 11.9853C37.4656 13.4679 35.077 14.7239 31.453 15.6505C29.9499 16.0212 28.5291 16.2683 27.4995 16.4124H27.5201Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7021 49.8318H9.33855C8.24723 49.8318 7.36182 48.9464 7.36182 47.8551V25.2256H44.7344V47.8551C44.7344 48.9464 43.849 49.8318 42.7577 49.8318H22.7021Z",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0376 16.4121V49.8313",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedemptionWhite);
export default __webpack_public_path__ + "static/media/RedemptionWhite.4f17c9e443b2f82e29fa8fc412b5b3a3.svg";
export { ForwardRef as ReactComponent };